import Gunluk from "../assets/images/Gunluk.jpg";
import ShortestPath from "../assets/images/ShortestPath.jpg";
import CarTracker from "../assets/images/CarTracker.jpg";
import SocialCampus from "../assets/images/SocialCampus.jpg";
import DeskSmart from "../assets/images/DeskSmart.png";
import BerrysApp from "../assets/images/BerrysApp.png";
import BrainGame from "../assets/images/BrainGame.png";

// NOT: `year` ve `platform` alanları tahminidir — kendine göre düzelt.
export const projectsData = [
  {
    title: "Berrys App",
    year: "2023",
    platform: "iOS · Android",
    description:
      "Sesli odalar ve anket akışı olan bir anlık iletişim uygulaması.",
    image: BerrysApp,
    tech: ["React Native", "Redux", "Agora", "Kochava"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/BerrysApp",
    features: [
      "Agora ile sesli oda altyapısı",
      "Anket oluşturma ve yanıtlama",
      "Kochava ile attribution ve analytics",
    ],
  },
  {
    title: "DeskSmart",
    year: "2022",
    platform: "iOS · Android",
    description:
      "Ofis masalarını gerçek zamanlı ayırtıp durumlarını takip eden bir uygulama.",
    image: DeskSmart,
    tech: ["React Native", "Firebase", "Redux"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/DeskSmart",
    features: [
      "Masa rezervasyonu",
      "Gerçek zamanlı doluluk durumu",
    ],
  },
  {
    title: "Car Tracker",
    year: "2022",
    platform: "Android",
    description:
      "Araç konumunu harita üzerinde canlı gösteren bir takip uygulaması.",
    image: CarTracker,
    tech: ["React Native", "Google Maps API", "Redux"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/CarTracker",
    features: [
      "Canlı konum takibi",
      "Google Maps entegrasyonu",
    ],
  },
  {
    title: "Sosyal Kampüs",
    year: "2021",
    platform: "iOS · Android",
    description:
      "Kampüs içi sosyal ağ: harita, gerçek zamanlı mesajlaşma ve öneri sistemi.",
    image: SocialCampus,
    tech: ["React Native", "Firebase", "Socket.io", "Fp-Growth"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/SocialCampus",
    features: [
      "Socket.io ile gerçek zamanlı akış",
      "Fp-Growth ile içerik önerisi",
      "Google Maps ile konum paylaşımı",
    ],
  },
  {
    title: "Günlük",
    year: "2021",
    platform: "Android",
    description:
      "Fotoğraf ve duygu durumuyla günlük tutmayı sağlayan bir uygulama.",
    image: Gunluk,
    tech: ["React Native", "Realm", "Redux"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/Gunluk",
    features: [
      "Realm ile çevrimdışı kayıt",
      "Fotoğraf ekleme",
      "Duygu durumu etiketi",
    ],
  },
  {
    title: "Zeka Oyunu",
    year: "2021",
    platform: "Android",
    description:
      "Satır ve sütun toplamlarını eşitlediğin, üç zorlukta bir sayı bulmacası.",
    image: BrainGame,
    tech: ["React Native", "Google Ads"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/BrainGame",
    features: [
      "4x4, 6x6, 8x8 tahtalar",
      "Kolay / orta / zor seviyeler",
    ],
  },
  {
    title: "En Kısa Yol",
    year: "2020",
    platform: "Android",
    description:
      "Noktalar arasındaki en kısa rotayı genetik algoritmayla çözen bir uygulama.",
    image: ShortestPath,
    tech: ["React Native", "PanResponder", "Genetic Algorithm"],
    demoLink: "#",
    githubLink: "https://github.com/MucahitTunel/ShortestPath",
    features: [
      "Dokunarak nokta yerleştirme",
      "Genetik algoritma ile optimizasyon",
    ],
  },
];
